export enum ArticleType {
  Article = 'article',
  Talk = 'talk',
}
